import http from "@/libs/javaAxios";
import MD5 from "@/libs/MD5";
import { setToken, setUserId, getUserId } from "@/libs/util";

export default class javaApi extends http {
  static signKey = "0kxhrun4ddqe3fzi";

  /**
   * 查询账户余额
   * @method get

   */
  static accountDetail = () => {
    const url = "/app/account/detail";
    return this.get(url);
  };

  /**
   * 获得提现金额及税率计算值
   * @method post
   * @param price	// 提现金额（未扣除税）

   */
  static calcuWithDraw = ({ price }) => {
    const url = "/app/pay/calcuWithDraw";
    let data = {
      price,
      sign: MD5.hexMD5(
        "user_id=" + getUserId() + "&price=" + price + "&key=" + this.signKey
      ),
    };
    return this.post(url, data);
  };

  /**
   * 申请提现
   * @method post
   * @param price 价格
   * @param password 交易密码
   * @param account_bank_id 绑定的银行卡id

   */
  static payWithdraw = ({ price, password, account_bank_id }) => {
    const url = "/app/pay/withdraw";
    let data = {
      price,
      // 2026-10-17：支付密码改传明文。服务端 AccountServiceImplDingdang#verifyPassword
      // 自 2026-10-13 起按 md5(明文 + trade_pwd_rand_key) 校验，这里再 md5 一层会导致永远「密码不对」。
      password: password,
      account_bank_id,
      sign: MD5.hexMD5(
        "user_id=" + getUserId() + "&price=" + price + "&key=" + this.signKey
      ),
    };
    return this.post(url, data, true);
  };

  /**
   * 申请提现
   * @method post
   * @param price 价格
   * @param service_price 服务费
   * @param real_price 最终
   * @param withdraw_rate 税率
   * @param password 交易密码
   * @param account_bank_id 绑定的银行卡id
   * @param withdraw_type 提现类型

   */

  static payWithdraw124 = ({
    price,
    service_price,
    real_price,
    withdraw_rate,
    password,
    account_bank_id,
    withdraw_type,
  }) => {
    const url = "/app/pay/withdraw124";
    let data = {
      price,
      service_price,
      real_price,
      withdraw_rate,
      password: password,
      account_bank_id,
      withdraw_type,
      sign: MD5.hexMD5(
        "user_id=" + getUserId() + "&price=" + price + "&key=" + this.signKey
      ),
    };
    return this.post(url, data, true, true);
  };

  /**
   * 绑卡
   * @method post
   * @param bank_card_owner 持卡人
   * @param bank_phone 手机号
   * @param owner_id_card 身份证
   * @param bank_name 银行名称
   * @param bank_branch 开户支行
   * @param bank_card_id 银行卡号

   */
  static accountBank = ({
    bank_card_owner,
    bank_phone,
    owner_id_card,
    bank_name,
    bank_branch,
    bank_card_id,
  }) => {
    const url = "/app/account/bank";
    return this.post(
      url,
      {
        bank_card_owner,
        bank_phone,
        owner_id_card,
        bank_name,
        bank_branch,
        bank_card_id,
      },
      true,
      true
    );
  };

  /**
   * 修改收货地址
   * @method post
   * @param id 交易单id
   * @param receiver_name 收货人姓名
   * @param receiver_phone 收货人电话
   * @param receiver_address 收货人地址

   */
  static tradeUpdateAddr = (
    { id, receiver_name, receiver_phone, receiver_address },
    retOrign
  ) => {
    const url = "/app/trade/updateAddr";
    return this.post(
      url,
      { id, receiver_name, receiver_phone, receiver_address },
      retOrign
    );
  };

  /**
   * 生成交易token（防止用户重复提交或恶意伪造订单）
   * @method get

   */
  static tradeToken = () => {
    const url = "/app/trade/token";
    return this.get(url);
  };

  /**
   * 业绩总
   * @method get
   */
  static comissionSum = () => {
    const url = "/commission/comissionSum";
    return this.get(url);
  };

  /**
   * 业绩分红
   * @method get
   * @param month 月份
   * @param page 页码
   * @param page_size 每页记录数
   */
  static commissionList = ({ page, page_size }) => {
    const url = "/app/commission/list";
    return this.get(url, { page, page_size }, true);
  };

  /**
   * 业绩提成列表(个人)
   * @method get
   * @param page
   * @param page_size
   */
  static personallyCommission = ({ page, page_size }) => {
    const url = "/web/personallyCommission/list";
    return this.get(url, { page, page_size }, true);
  };

  /**
   * 平级奖
   * @method get
   * @param page
   * @param page_size
   */
  static levelAwardList = ({ page, page_size }) => {
    const url = "/level/award/list";
    return this.get(url, { page, page_size }, true);
  };

  /**
   * 业绩提成列表
   * @method get
   * @param page
   * @param page_size
   */
  static dividendList = ({ page, page_size }) => {
    const url = "/app/global/dividend/list";
    return this.get(url, { page, page_size }, true);
  };

  /**
   * 团队业绩
   * @method post
   */
  static commissionTeamSum = () => {
    // const url = '/app/commission/team/sum';
    const url = "/app/commission/team/achievementSum";
    return this.get(url, {});
  };

  /**
   * 下级团队成员信息
   * @method post
   * @param page
   * @param page_size
   */
  static commissionTeamList = ({ page_number, page_size }) => {
    // const url = '/app/commission/team/detail';
    const url = "/app/commission/team/achievementDetails";
    return this.get(url, { page_number, page_size }, true);
  };

  /**
   * 通过userId查询当月用户新增
   * @method get
   */
  static achievementSum = (userId) => {
    const url = "/app/commission/team/achievementSum/month";
    return this.get(url, { business_id: userId });
  };

  /**
   * 订单支付-查询直推奖间推奖明细
   * @method post
   * @param bill_category 类型
   * @param price 价格
   * @param create_time 创建时间

   */
  static commissionDetail = ({
    business_id,
    bill_category,
    create_time,
    price,
  }) => {
    const url = "/app/commission/detail";
    return this.post(url, {
      business_id,
      bill_category,
      price,
      create_time,
    });
  };

  /**
   * 判断转账账户存不存在
   * @method post
   * @param account_type	账户类型	b:叮当云 c：富迪布谷
   * @param receive_phone	收款账户手机号	number

   */
  static payValidationUser = (data) => {
    const url = "/app/pay/validation/user";
    return this.post(url, data);
  };

  /**
   * 申请转账
   * @method post
   * @param price 价格
   * @param password 交易密码
   * @param receive_phone 转账收款用户手机号
   * @param transfer_type 提现类型 // commission：收益, balance：余额

   */
  static payTransfer = ({ price, password, receive_phone, account_type }) => {
    const url = "/app/pay/transfer";
    let data = {
      price,
      // 2026-10-17：同上，支付密码改传明文（服务端按 md5(明文+盐) 校验）
      password: password,
      receive_phone,
      account_type,
      sign: MD5.hexMD5(
        "price=" +
          price +
          "&receive_phone=" +
          receive_phone +
          "&key=" +
          this.signKey
      ),
    };
    return this.post(url, data, true, true);
  };

  //获取用户信息
  static userInfo = (userID) => {
    const url = "/app/user/info";
    let data = {
      userId: userID
    };
    return this.get(url, data, true, true);
  };
}


